<template>
  <div>
    <b-dropdown
      size="sm"
      variant="link-info"
      toggle-class="text-decoration-none"
      ref="otherButtonDropdown"
      boundary="window"
    >
      <template #button-content>
        <span class="text-dark text-content"> {{ buttonContent }} </span>
      </template>
      <slot name="other-buttons" />
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    buttonContent: {
      type: String,
      default: ''
    }
  },
  mounted() {},
  methods: {
    hideDropdown() {
      this.$refs.otherButtonDropdown.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.text-content {
  @include responsive-fs(12);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/OtherButton.vue